import { ApplicationConfig, importProvidersFrom } from '@angular/core';

import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { AuthModule } from '@auth0/auth0-angular';

import { routes } from './app.routes';
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
    withXhr,
} from '@angular/common/http';
import { BaseUrlInterceptor } from './core/interceptors/base-url-interceptor';

import { environment } from '../environments/environment';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { EWA_DATE_PIPE_DEFAULT_OPTIONS } from './core/constants/date-pipe';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { EWA_MAT_DIALOG_DEFAULT_OPTIONS } from './core/constants/mat-dialog';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { EWA_MAT_SELECT_DEFAULT_OPTIONS } from './core/constants/mat-select';
import { AG_GRID_PROVIDER } from './core/configurations/providers/ag-grid.provider';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        provideEnvironmentNgxMask(),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BaseUrlInterceptor,
            multi: true,
        },
        importProvidersFrom(
            AuthModule.forRoot({
                ...environment.auth0,
            }),
        ),
        {
            provide: DATE_PIPE_DEFAULT_OPTIONS,
            useValue: {
                ...EWA_DATE_PIPE_DEFAULT_OPTIONS,
            },
        },
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: EWA_MAT_DIALOG_DEFAULT_OPTIONS,
        },
        {
            provide: MAT_SELECT_CONFIG,
            useValue: EWA_MAT_SELECT_DEFAULT_OPTIONS,
        },
        AG_GRID_PROVIDER,
    ],
};
